import _regeneratorRuntime from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */
import { LazyIterator, OneToManyIterator } from './lazy_iterator';
export var StringIterator = /*#__PURE__*/function (_LazyIterator) {
  _inherits(StringIterator, _LazyIterator);

  function StringIterator() {
    _classCallCheck(this, StringIterator);

    return _possibleConstructorReturn(this, _getPrototypeOf(StringIterator).apply(this, arguments));
  }

  _createClass(StringIterator, [{
    key: "split",

    /**
     * Splits a string stream on a given separator.
     *
     * It is assumed that the incoming chunk boundaries have no semantic meaning,
     * so conceptually the incoming stream is treated simply as the concatenation
     * of its elements.
     *
     * The outgoing stream provides chunks corresponding to the results of the
     * standard string split() operation (even if such a chunk spanned incoming
     * chunks).  The separators are not included.
     *
     * A typical usage is to split a text file (represented as a stream with
     * arbitrary chunk boundaries) into lines.
     *
     * @param upstream A readable stream of strings that can be treated as
     *   concatenated.
     * @param separator A character to split on.
     */
    value: function split(separator) {
      return new SplitIterator(this, separator);
    }
  }]);

  return StringIterator;
}(LazyIterator); // ============================================================================
// The following private classes serve to implement the chainable methods
// on StringIterator.  Unfortunately they can't be placed in separate files, due
// to resulting trouble with circular imports.
// ============================================================================
// We wanted multiple inheritance, e.g.
//   class SplitIterator extends QueueIterator<string>, StringIterator
// but the TypeScript mixin approach is a bit hacky, so we take this adapter
// approach instead.

var SplitIterator = /*#__PURE__*/function (_StringIterator) {
  _inherits(SplitIterator, _StringIterator);

  function SplitIterator(upstream, separator) {
    var _this;

    _classCallCheck(this, SplitIterator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SplitIterator).call(this));
    _this.upstream = upstream;
    _this.impl = new SplitIteratorImpl(upstream, separator);
    return _this;
  }

  _createClass(SplitIterator, [{
    key: "summary",
    value: function summary() {
      return this.impl.summary();
    }
  }, {
    key: "next",
    value: function () {
      var _next = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.impl.next());

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function next() {
        return _next.apply(this, arguments);
      }

      return next;
    }()
  }]);

  return SplitIterator;
}(StringIterator);

var SplitIteratorImpl = /*#__PURE__*/function (_OneToManyIterator) {
  _inherits(SplitIteratorImpl, _OneToManyIterator);

  function SplitIteratorImpl(upstream, separator) {
    var _this2;

    _classCallCheck(this, SplitIteratorImpl);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(SplitIteratorImpl).call(this));
    _this2.upstream = upstream;
    _this2.separator = separator; // A partial string at the end of an upstream chunk

    _this2.carryover = '';
    return _this2;
  }

  _createClass(SplitIteratorImpl, [{
    key: "summary",
    value: function summary() {
      return "".concat(this.upstream.summary(), " -> Split('").concat(this.separator, "')");
    }
  }, {
    key: "pump",
    value: function () {
      var _pump = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var chunkResult, lines, _iterator, _step, line;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.upstream.next();

              case 2:
                chunkResult = _context2.sent;

                if (!chunkResult.done) {
                  _context2.next = 9;
                  break;
                }

                if (!(this.carryover === '')) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", false);

              case 6:
                // Pretend that the pump succeeded in order to emit the small last batch.
                // The next pump() call will actually fail.
                this.outputQueue.push(this.carryover);
                this.carryover = '';
                return _context2.abrupt("return", true);

              case 9:
                lines = chunkResult.value.split(this.separator); // Note the behavior: " ab ".split(' ') === ['', 'ab', '']
                // Thus the carryover may be '' if the separator falls on a chunk
                // boundary; this produces the correct result.

                lines[0] = this.carryover + lines[0];
                _iterator = _createForOfIteratorHelper(lines.slice(0, -1));

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    line = _step.value;
                    this.outputQueue.push(line);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                this.carryover = lines[lines.length - 1];
                return _context2.abrupt("return", true);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function pump() {
        return _pump.apply(this, arguments);
      }

      return pump;
    }()
  }]);

  return SplitIteratorImpl;
}(OneToManyIterator);